import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '仪表盘', icon: 'dashboard'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/member',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'member',
        name: 'umsMember',
        component: () => import('@/views/ums/member/index'),
        meta: {title: '会员管理', icon: 'user'}
      },
      {
        path: 'member/detail/:id',
        name: 'memberDetail',
        component: () => import('@/views/ums/member/detail'),
        meta: {title: '会员详情'},
        hidden: true
      }
    ]
  },
  {
    path: '/lottery',
    component: Layout,
    redirect: '/lottery/product',
    name: 'lottery',
    meta: { title: '抽奖管理', icon: 'lottery' },
    children: [
      {
        path: 'product',
        name: 'lotteryProduct',
        component: () => import('@/views/lottery/product/index'),
        meta: { title: '抽奖商品', icon: 'product-list' }
      },
      {
        path: 'addProduct',
        name: 'addLotteryProduct',
        component: () => import('@/views/lottery/product/add'),
        meta: { title: '创建抽奖商品', icon: 'product-add' }
      },
      {
        path: 'participants/:productId',
        name: 'lotteryParticipants',
        component: () => import('@/views/lottery/product/participants'),
        meta: { title: '参与者列表' },
        hidden: true
      },
      {
        path: 'product/periods/:id',
        name: 'lotteryPeriods',
        component: () => import('@/views/lottery/product/periods'),
        meta: { title: '期数管理' },
        hidden: true
      },
      {
        path: 'product/award/:id',
        name: 'lotteryAward',
        component: () => import('@/views/lottery/product/award'),
        meta: { title: '发奖管理' },
        hidden: true
      },
      {
        path: 'review/pending',
        name: 'reviewPending',
        component: () => import('@/views/lottery/review/pending'),
        meta: { title: '待审核领奖', icon: 'review' }
      },
      {
        path: 'review/history',
        name: 'reviewHistory',
        component: () => import('@/views/lottery/review/history'),
        meta: { title: '审核历史', icon: 'history' }
      },
      {
        path: 'specified',
        name: 'specifiedWinning',
        component: () => import('@/views/lottery/specified/index'),
        meta: { title: '指定中奖', icon: 'specified' }
      },
      {
        path: 'specified/history',
        name: 'specifiedHistory',
        component: () => import('@/views/lottery/specified/history'),
        meta: { title: '指定中奖历史' },
        hidden: true
      },
      {
        path: 'stats',
        name: 'lotteryStats',
        component: () => import('@/views/lottery/stats/index'),
        meta: { title: '统计分析', icon: 'stats' }
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  mode: 'hash', // 使用hash模式避免刷新空白问题
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js